import { createElement } from 'react';
import { Table as OriginalTable } from 'antd';
import './index.scss';
const Table = function Table({ ...otherProps }) {
    const _otherProps = otherProps || {};
    return (createElement(OriginalTable, { ..._otherProps }));
};
Table.displayName = 'Table';
export default Table;
